import React from "react";
import { IconProp } from ".";
export default function AlertIcon(props: IconProp) {
    const {width=120, height=120} = props;

    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 186 186" fill="none">
                <g filter="url(#filter0_d_685_12621)">
                    <circle cx="93" cy="93" r="62.5" fill="#FFB800" />
                </g>
                <path d="M93 68V99.25" stroke="white" strokeWidth="12.5" strokeLinecap="round" />
                <circle cx="93" cy="118" r="6.25" fill="white" />
                <defs>
                    <filter
                        id="filter0_d_685_12621"
                        x="0.500002"
                        y="0.500002"
                        width="185"
                        height="185"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="15" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.72 0 0 0 0 0 0 0 0 1 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_685_12621" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_685_12621" result="shape" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
}
